var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-select" }, [
    _vm.files.length
      ? _c(
          "div",
          { staticClass: "file-select__files" },
          _vm._l(_vm.files, function(file) {
            return _c("div", [
              _vm._v("\n            " + _vm._s(file.name) + "\n        ")
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "file-select__button",
        attrs: { type: "button" },
        on: { click: _vm.onBtnClick }
      },
      [_c("file-icon"), _vm._v("\n        Vælg filer\n    ")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }